import { useEffect } from 'react';
import httpClient from '../../datasources/httpClient';
import useAuth from '../../hooks/useAuth';

export default function AuthInterceptor({ children }) {
  const { handleLogout } = useAuth();

  useEffect(() => {
    const resInterceptor = (response) => response;

    const errInterceptor = async (error) => {
      if (error.response.status === 401) {
        const refreshToken = localStorage.getItem('refreshToken');
        const { id } = JSON.parse(localStorage.getItem('user'));

        const response = await httpClient.post('auth/token', {
          userId: id,
          refreshToken,
        });

        if (response.status === 200) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('refreshToken', response.data.refreshToken);
        } else {
          handleLogout();
        }
      }

      return Promise.reject(error);
    };

    const interceptor = httpClient.interceptors.response.use(resInterceptor, errInterceptor);

    return () => httpClient.interceptors.response.eject(interceptor);
  }, []);

  return children;
}
